<script>
  import DiagramItem from './Item.svelte';

  export let items;
  export let diagramArrow;
</script>

<div class="diagram">
  {#each items as item}
    <DiagramItem {item} {diagramArrow} />
  {/each}
</div>

<style lang="scss">
  .diagram {
    display: flex;
    gap: 3rem;
    row-gap: 1rem;
    margin-top: 5rem;
    flex-wrap: wrap;
  }
</style>
